const NOT_REGISTERED = 'No matching bindings found for target, Did you forget @inject for interface?';
const generatePostConstructorError = (useClass, token, errorMsg) => `postConstruct error in class ${useClass.name}, with key ${String(token)}:${errorMsg} `;

export { NOT_REGISTERED, generatePostConstructorError };
//# sourceMappingURL=error-msgs.js.map
